import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'react-bootstrap';

import withIdContext from '../../decorators/withIdContext';
import withId from '../../decorators/withId';

const PAGINATION_RADIUS = 3;

export const First = withId('First')(Pagination.First);
export const Prev = withId('Prev')(Pagination.Prev);
export const Item = withId('Page')(Pagination.Item);
export const Next = withId('Next')(Pagination.Next);
export const Last = withId('Last')(Pagination.Last);

export const PaginationBar = ({
  currentPage,
  totalPages: totalPagesOrig,
  onSelectPage,
}) => {
  const totalPages = totalPagesOrig || 1;
  const startUnderflow = -Math.min(currentPage - (1 + PAGINATION_RADIUS), 0);
  const endOverflow = -Math.min(totalPages - (currentPage + PAGINATION_RADIUS), 0);

  const startPage = Math.max(currentPage - (PAGINATION_RADIUS + endOverflow), 1);
  const endPage = Math.min(currentPage + (PAGINATION_RADIUS + startUnderflow), totalPages);

  const items = [];
  for (let i = startPage; i <= endPage; i += 1) {
    items.push(
      <Item key={i} active={i === currentPage} onClick={() => onSelectPage(i)} id={i}>
        {i}
      </Item>,
    );
  }

  const previousPage = Math.max(currentPage - 1, 1);
  const nextPage = Math.min(currentPage + 1, totalPages);

  return (
    <Pagination bsClass="pagination PaginationBar">
      <First data-id="First" disabled={currentPage === 1} onClick={() => onSelectPage(1)} />
      <Prev data-id="Prev" disabled={currentPage === 1} onClick={() => onSelectPage(previousPage)} />
      {items}
      <Next data-id="Next" disabled={currentPage === totalPages} onClick={() => onSelectPage(nextPage)} />
      <Last data-id="Last" disabled={currentPage === totalPages} onClick={() => onSelectPage(totalPages)} />
    </Pagination>
  );
};

PaginationBar.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onSelectPage: PropTypes.func,
};

PaginationBar.defaultProps = {
  currentPage: 1,
  totalPages: 1,
  onSelectPage: () => {},
};


export default withIdContext('PaginationBar')(PaginationBar);
